import { getTime, sub } from 'date-fns';
import { Shortcut } from 'shared/mui/DatePicker/components/DatePickerShortcuts/DatePickerShortcuts';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import {
  getZonedEndOfDay,
  getZonedEndOfMonth,
  getZonedEndOfWeek,
  getZonedStartOfDay,
  getZonedStartOfMonth,
  getZonedStartOfWeek,
} from 'shared/mui/DatePicker/utils/getZonedTime';

export type Shortcuts = (timezone: string) => Shortcut[][];

export const DEFAULT_SHORTCUTS: Shortcuts = (timezone: string = DEFAULT_TIMEZONE) => [
  [
    {
      alias: '1',
      label: 'app.datePicker.shortcuts.today',
      getValue: () => {
        const today = new Date();
        return [
          getTime(getZonedStartOfDay(today, timezone)),
          getTime(getZonedEndOfDay(today, timezone)),
        ];
      },
    },
    {
      alias: '2',
      label: 'app.datePicker.shortcuts.yesterday',
      getValue: () => {
        const today = new Date();
        const yesterday = sub(today, { days: 1 });
        return [
          getTime(getZonedStartOfDay(yesterday, timezone)),
          getTime(getZonedEndOfDay(yesterday, timezone)),
        ];
      },
    },
    {
      alias: '3',
      label: 'app.datePicker.shortcuts.currentWeek',
      getValue: () => {
        const today = new Date();
        return [
          getTime(getZonedStartOfWeek(today, timezone)),
          getTime(getZonedEndOfDay(today, timezone)),
        ];
      },
    },
    {
      alias: '4',
      label: 'app.datePicker.shortcuts.lastWeek',
      getValue: () => {
        const today = new Date();
        const prevWeek = sub(today, { days: 7 });
        return [
          getTime(getZonedStartOfWeek(prevWeek, timezone)),
          getTime(getZonedEndOfWeek(prevWeek, timezone)),
        ];
      },
    },
    {
      alias: '5',
      label: 'app.datePicker.shortcuts.currentMonth',
      getValue: () => {
        const today = new Date();
        return [
          getTime(getZonedStartOfMonth(today, timezone)),
          getTime(getZonedEndOfDay(today, timezone)),
        ];
      },
    },
    {
      alias: '6',
      label: 'app.datePicker.shortcuts.lastMonth',
      getValue: () => {
        const today = new Date();
        const prevMonth = sub(today, { months: 1 });
        return [
          getTime(getZonedStartOfMonth(prevMonth, timezone)),
          getTime(getZonedEndOfMonth(prevMonth, timezone)),
        ];
      },
    },
  ],
  [
    {
      alias: '7',
      label: 'app.datePicker.shortcuts.last24Hours',
      getValue: () => {
        const today = new Date();
        return [getTime(sub(today, { hours: 24 })), getTime(today)];
      },
    },
    {
      alias: '8',
      label: 'app.datePicker.shortcuts.last7Days',
      getValue: () => {
        const today = new Date();
        return [getTime(sub(today, { days: 7 })), getTime(today)];
      },
    },
    {
      alias: '9',
      label: 'app.datePicker.shortcuts.last30Days',
      getValue: () => {
        const today = new Date();
        return [getTime(sub(today, { days: 30 })), getTime(today)];
      },
    },
  ],
];
